import React, {  useState, useEffect} from 'react';
import { 
  User, Mail, Phone, Edit, Trash2,  ChevronDown, ChevronUp,
  Check, Bike, MessageSquareText, MapPin,
  Motorbike
} from 'lucide-react';
import '../css/TRB.css';
import axios from 'axios';

const Institutional = () => {
  const [expandedFormId, setExpandedFormId] = useState(null);
  const [editingFormId, setEditingFormId] = useState(null);
  const [formsData, setFormsData] = useState([]);
  const [editedform, setEditedForm] = useState([]);

   useEffect(() => {
      const fetchSales = async () => {
        console.log('entered here useEffect');
       try {
        const res = await axios.get('/api/institutional');
        console.log('response', res.data);
        setFormsData(res.data);
       } catch (error) {
         console.error("Error fetching institutional sales list:", error);
       }
      };
      fetchSales();
    }, []);

  // Sample form data - 3 forms
  // const formsData = [
  //   {
  //     id: '001',
  //     submittedAt: '2024-10-29 10:30 AM',
      
  //     name: 'Alice Johnson',
  //     email: 'alice.johnson@example.com',
  //     phone: '+1 (555) 123-4567',
  //     city:'Bangalore',
  //     state:'Karnataka',
  //     interest:'Booking'
  //   },
  //   {
  //     id: '002',
  //     submittedAt: '2024-10-28 02:15 PM',
     
  //     name: 'Robert Martinez',
  //     email: 'robert.martinez@example.com',
  //     phone: '+1 (555) 987-6543',
  //     city:'Mumbai',
  //     state:'Maharashtra',
  //     interest:'Booking and Test Ride'
  //   },
  //   {
  //     id: '003',
  //     submittedAt: '2024-10-27 04:45 PM',
      
  //     name: 'Emily Chen',
  //     email: 'emily.chen@example.com',
  //     phone: '+1 (555) 456-7890',
  //     city:'Udupi',
  //     state:'Karnataka',
  //     interest:'Test Ride'
  //   }
  // ];

  const toggleForm = (formId) => {
    if (expandedFormId === formId) {
      setExpandedFormId(null);
    } else {
      setExpandedFormId(formId);
      setEditingFormId(null); // Close edit mode when switching forms
    }
  };

  const handleEdit = (formId) => {
    setEditingFormId(editingFormId === formId ? null : formId);
    const form = formsData.find(f => f._id === formId);
    setEditedForm({...form});
    
  };

  const handleSave = async(formId) => {
    // Add save logic here
    console.log('entered save function');
    try {
      const res = await axios.put(`/api/editsales/${formId}`, editedform);
      console.log('response', res.data);
      const updated = res.data;
      setFormsData(prev => prev.map(form => form._id === formId ? updated : form));
      setEditingFormId(null);
      alert('Changes saved successfully!');
    } catch(err) {
      console.log('error', err);
      alert('Failed to update');
    }
    
  };

  const handleDelete = async(formId) => {
    if (window.confirm('Are you sure you want to delete this form submission?')) {
      try {
        const res = await axios.delete(`/api/deletesale/${formId}`);
        setFormsData(prev => prev.filter(form => form._id != formId));
         console.log('Form deleted:', formId);
      alert('Form deleted successfully!');
    }
    catch (error) {
      console.log('error', error);
      alert('Failed to delete');
    }
      }
  };

//   const handleAction = (action, formId) => {
//     console.log(`Action: ${action} for Form: ${formId}`);
//     alert(`Form ${formId} marked as ${action}!`);
//   };

  return (
    <div className="form-details-container">
      {/* Header Section */}
      <div className="forms-header">
        <div className="header-info">
          <h1>Institutional Sales</h1>
          <p>Institutional Sales form details from the website</p>
        </div>
       
      </div>

      {/* Forms List */}
      <div className="forms-list">
        {formsData.map((form) => (
          <div key={form._id} className={`form-card ${expandedFormId === form._id ? 'expanded' : ''}`}>
            {/* Form Card Header - Always Visible */}
            <div className="form-card-header" onClick={() => toggleForm(form._id)}>
              <div className="form-card-left">
                <div className="form-avatar">
                  <User size={24} />
                </div>
                <div className="form-basic-info">
                  <h3 className="form-name">{form.name}</h3>
                  <p className="form-id-text">{form._id}</p>
                </div>
              </div>
              <div className="form-card-right">
               
                <span className="form-submitted-time">{new Date(form.submittedAt).toISOString().split('T')[0]}</span>
                <button className="expand-btn">
                  {expandedFormId === form._id ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </button>
              </div>
            </div>

            {/* Form Card Details - Expandable */}
            {expandedFormId === form._id && (
              <div className="form-card-details">
                {/* Action Buttons */}
                <div className="detail-actions">
                  <button className="action-btn secondary" onClick={() => handleEdit(form._id)}>
                    <Edit size={16} />
                    {editingFormId === form._id ? 'Cancel' : 'Edit'}
                  </button>
                  
                 
                  <button className="action-btn danger" onClick={() => handleDelete(form._id)}>
                    <Trash2 size={16} />
                    Delete
                  </button>
                </div>

                {/* Personal Information */}
                <div className="details-section">
                  <div className="section-header"> 
                    <h3>Personal Information</h3>
                    {editingFormId === form._id && (
                      <button className="save-btn" onClick={() => handleSave(form._id)}>
                        <Check size={16} />
                        Save
                      </button>
                    )}
                  </div>
                  
                  <div className="details-grid">
                    <div className="detail-item">
                      <div className="detail-label">
                        <User size={16} className="detail-icon" />
                        <span>Full Name</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="text" 
                          className="detail-input" 
                          defaultValue={editedform.name}
                          onChange={e => setEditedForm({...editedform, name: e.target.value})}
                        />
                      ) : (
                        <div className="detail-value">{form.name}</div>
                      )}
                    </div>

                    <div className="detail-item">
                      <div className="detail-label">
                        <Mail size={16} className="detail-icon" />
                        <span>Email</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="email" 
                          className="detail-input" 
                          defaultValue={editedform.email}
                          onChange={e => setEditedForm({...editedform, email: e.target.value})}
                        />
                      ) : (
                        <div className="detail-value">
                          <a href={`mailto:${form.email}`} className="link">
                            {form.email}
                          </a>
                        </div>
                      )}
                    </div>

                    <div className="detail-item">
                      <div className="detail-label">
                        <Phone size={16} className="detail-icon" />
                        <span>Phone</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="tel" 
                          className="detail-input" 
                          defaultValue={editedform.phone}
                          onChange={e => setEditedForm({...editedform, phone: e.target.value})}
                        />
                      ) : (
                        <div className="detail-value">
                          <a href={`tel:${form.phone}`} className="link">
                            {form.phone}
                          </a>
                        </div>
                      )}
                    </div>

                    <div className="detail-item">
                      <div className="detail-label">
                        <Bike size={16} className="detail-icon" />
                        <span>City</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="text" 
                          className="detail-input" 
                          defaultValue={editedform.city}
                          onChange={e => setEditedForm({...editedform, city: e.target.value})}
                        />
                      ) : (
                        <div className="detail-value">{form.city}</div>
                      )}
                    </div>

                    <div className="detail-item">
                      <div className="detail-label">
                        <MapPin size={16} className="detail-icon" />
                        <span>State</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="text" 
                          className="detail-input" 
                          defaultValue={editedform.state}
                          onChange={e => setEditedForm({...editedform, state: e.target.value})}
                        />
                      ) : (
                        <div className="detail-value">{form.state}</div>
                      )}
                    </div>

                <div className="detail-item">
                      <div className="detail-label">
                        <Motorbike size={16} className="detail-icon" />
                        <span>Choosen Interest</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="text" 
                          className="detail-input" 
                          defaultValue={editedform.interest}
                          onChange={e => setEditedForm({...editedform, interest: e.target.value})}
                        />
                      ) : (
                        <div className="detail-value">{form.interest}</div>
                      )}
                    </div>

                     

                     

                     

                    
                    
                  </div>
                </div>

               
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Institutional;


